<template>
  <div>
    <div class="row m-b-sm">
      <v-select
        class="col-lg-3"
        placeholder="QA Type"
        :options="uniqueTypes"
        v-model="tableFilter['qaType']"
      ></v-select>
      <v-select
        class="col-lg-3"
        placeholder="Result"
        :options="resultStatus"
        index="index" label="txt"
        v-model="tableFilter['result']"
      ></v-select>
    </div>
    <div class="row">
      <div class="col-lg-3" style="margin-top:1.3em">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>
  <!--            <span v-if="user.admin">-->
  <!--              <button class="btn btn-primary btn-xs" @click="runQa('production')"><i class="fa fa-play"></i> Prod</button>-->
  <!--              <button class="btn btn-warning btn-xs" @click="runQa('stage')"><i class="fa fa-play"></i> Stage</button>-->
  <!--            </span>-->
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="check in checksTable" :key="check.id"  @click="activeCheck = check" style="cursor: pointer">
            <td style="text-align: center;">
              <span v-if="check.success"><i class="fa fa-check green"></i></span>
              <span v-else :class="check.failType === 'hard' ? 'red' : 'orange'">{{ check.fails }}</span>
            </td>
            <td>
              <div :class="'label label-' + (check.success ? 'primary' : (check.failType === 'hard' ? 'danger' : 'warning'))">{{ check.type }}</div>
            </td>
            <td>
              {{ check.time | aTime('DD.MM. HH:mm') }}
            </td>
            <td class="green">{{ check.messages.length }}</td>
            <td class="orange">{{ check.warnings.length }}</td>
            <td class="red">{{ check.errors.length }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-9">
        <div v-if="activeCheck">
          <h3>
            <span :class="'label label-' + (activeCheck.success ? 'primary' : 'danger')">{{ activeCheck.type }}</span>
            <span v-if="activeCheck.success">OK</span>
            <span v-else> fail #{{ activeCheck.fails }} </span>
            on {{ activeCheck.time | aTime('DD.MM. @ HH:mm') }}</h3>
          <table class="table table-hover">
            <tbody>
            <tr v-for="(e, i) in activeCheck.errors" :key="'error-' + i">
              <td>
                <i class="fa fa-warning red"></i> {{ e }}
              </td>
            </tr>
            <tr v-for="(w, i) in activeCheck.warnings" :key="'warning-' + i">
              <td>
                <i class="fa fa-warning orange"></i> {{ w }}
              </td>
            </tr>
            <tr v-for="(m, i) in activeCheck.messages" :key="'message-' + i">
              <td>
                <i class="fa fa-check green"></i> {{ m }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      checks: [],
      activeCheck: null,
      uniqueTypes: [],
      tableFilter: {},
      resultStatus: [
        {index: true, txt: 'Successful'},
        {index: false, txt: 'Failing'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      site: 'getPbn',
      user: 'getUser'
    }),
    checksTable () {
      let newChecks = this.checks
      if (this.tableFilter['result'] !== undefined && this.tableFilter['result'] !== null) {
        newChecks = this.tableFilter['result'] ? newChecks.filter(c => c.success) : newChecks.filter(c => c.fails > 0)
      }
      if (this.tableFilter['qaType']) {
        newChecks = newChecks.filter(c => c.type === this.tableFilter['qaType'])
      }
      return newChecks
    }
  },
  watch: {
    site () {
      this.loadChecks()
    }
  },
  mounted () {
    this.loadChecks()
  },
  methods: {
    loadChecks () {
      axios.get('/pbn/site/' + this.site.punyDomain + '/qa')
        .then(r => {
          this.checks = r.data.data
          if (this.checks.length) {
            this.activeCheck = this.checks[0]
          }
          this.uniqueTypes = [...new Set(this.checks.map(c => c.type))]
        })
        .catch()
    },
    runQa (env = 'production') {
      axios.post('/pbn/site/' + this.site.punyDomain + '/qa?env=' + env)
        .then(r => {
          this.$toastr.success(`QA on ${env} started, check it in a minute or so`, 'Good')
        })
        .catch(e => {
          this.$toastr.error(e, 'QA Failed')
        })
    },
    markFixed (checkId, msgId, checkData) {
      axios.put('/pbn/site/' + this.site.punyDomain + '/qa/fix', {
        check: this.activeCheck.id,
        checkId: checkId,
        msgId: msgId,
        checkData: checkData
      })
        .then(r => {
          this.checks = r.data.checks
          this.activeCheck = this.checks[checkId]
          this.$toastr.success('Issue fixed', 'Thi issue has been flagged as fixed and QA on production triggered')
        })
        .catch(e => {
          this.$toastr.error(e, 'We have encountered an issue')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Qa.vue